import React, { useState, useEffect } from 'react';
import DateAndTime from '../../../libs/genericFunctions';

const ConferenceRoomHdr = (props) =>
{
	const [ timeData, setTimeData ] = useState(DateAndTime());
	// const [ roomName, setRoomName ] = useState('');

	useEffect(() =>
	{
		// async function getRoomData()
		// {
		// 	const roomNameData = await window?.electron?.ipcRenderer?.invoke('getRoomData', 'roomName');

		// 	if (roomNameData)
		// 	{
		// 		setRoomName(roomNameData);
		// 	}
		// }
		// getRoomData();
		const intervalId = setInterval(() =>
		{
			setTimeData(DateAndTime());
		}, 1000);

		return () => clearInterval(intervalId);
	}, []);

	return (
		<div className='flexCol fullH'>
			<div className='flexRow aCntr pdngXS positionRelative'>
				<div className='flexAutoRow'>
					<div className='meetingRoomsLogo'>
						<img src='/icons/meetingRooms.svg' alt='inMeetLogo' className='img' />
					</div>
				</div>
				<div className='flexMinWidthCol wTxt textCntr'>
					<span className='fontMD fontWeight500'>{props?.roomName}</span>
					<span>{`${timeData.Date} - ${timeData.Time}`}</span>
				</div>
				{!props?.isOnline && <div className='flexAutoRow nointernetAbs blink'>
					<div className='flexInline aCntr jEvenly'>
						<span className='noInternetdot'/>
						<span className='noInternet pdngLSM'>No Internet</span>
					</div>
				</div>}
				<div className='flexAutoRow pointer' onClick={() => props?.setRefresh((prevState) => !prevState)}>
					<div className='flexInline aCntr jEvenly refreshBtn wTxt '>
						<div className='refreshBtnSize'>
							<img src='/icons/refreshBtn.svg' alt='inMeetLogo' className='img' />
						</div>
						<span className='wTxt'>Refresh</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConferenceRoomHdr;